// This component is last tab of Application form. // Confirm Information and
Submit or Update Information
<template>
  <div class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6">
    <div class="md:grid md:grid-cols-2 md:gap-6 px-6">
      <div class="md:col-span-1">
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          PREVIEW & COMPLETE
        </h3>
        <p class="mt-1 text-sm text-gray-500">
          Please review the below information and sign the application. When
          complete, hit the Submit button.
        </p>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form @submit.prevent="submitApplication" novalidate class="space-y-6">
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
              <h4 class="text-lg font-bold">DISCLAIMERS</h4>
              <div
                class="barley-corn-bg-color border-l-4 cobalt-border-color p-4"
              >
                <div class="flex">
                  <div class="flex-shrink-0">
                    <!-- Heroicon name: solid/information-circle -->
                    <svg
                      class="h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <div class="text-sm text-white">
                      <!-- For All Attorney Type-->
                      <div>
                        Please attach a copy of the declaration page from your
                        professional liability policy.
                        <br /><br />
                        I verify that the information contained within this
                        application is accurate and complete. I attest that I am
                        a licensed attorney in the jurisdictions I have
                        indicated and am in good standing with all relevant
                        Bar(s) regulatory authorities. I agree that I will not
                        directly or indirectly market or sell any other products
                        or services other than that to which this agreement
                        pertains. I also agree that I may terminate this
                        agreement with 30 days written notice to U.S. Legal
                        Services and that I will complete any legal undertaking
                        on behalf of Plan Members, i.e., my clients, pursuant to
                        applicable Canons of Ethics to which I am sworn to
                        adhere.
                        <br /><br />
                      </div>
                      <!-- For FAM  Attorney Type -->
                      <div v-if="form.attorney_type.includes('FAM')">
                        I agree to the terms of the U.S. Legal Services Fee for
                        Services Attorney Agreement, Participating Attorney Fee
                        Reimbursement Schedule, Plan Descriptions, Specific Plan
                        and Policy Limitations and/or Exclusions, and any
                        subsequent revisions thereof.
                      </div>
                      <!-- For REF Attorney Type -->
                      <div v-if="form.attorney_type.includes('REF')">
                        I agree to accept referrals of U. S. Legal Plan Members
                        to provide a free consultation and bill the member
                        directly at a discount of at least 33.3% off my normal
                        hourly rate for Non-Covered legal services.
                      </div>
                      <!-- For CDL Attorney Type -->
                      <div v-if="form.attorney_type.includes('CDL')">
                        I agree to represent to completion U.S. Legal's CDL
                        Defender Plan Members for the flat fee by county(ies)
                        indicated within this application for moving, non-moving
                        and D.O.T. traffic citations. Additionally, I agree to
                        accept referrals of CDL Defender Plan Members, for
                        matters other than CDL cases and I agree to provide a
                        free consultation and bill the member directly at a
                        discount of at least 33.3% off my normal hourly rate for
                        Non-Covered legal services. <br />
                        <br />

                        I understand that CDL case invoice(s)/claim(s) will be
                        processed as follows by U.S. Legal: Attorney invoices
                        received by U.S. Legal by the 24th of the month, payment
                        will be mailed or direct deposited by the 5th business
                        day of the following month.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- If attorney type includes FAM -->
              <div
                v-if="form.attorney_type.includes('FAM')"
                class="tooltip bg-[#d9f9f9]   p-4 text-[#1f3341]"
              >
                <i class="fa fa-info-circle text-[#1f3341]"></i>
                Please review the Fee for Services Attorney Agreement
                <a
                  href="https://hubs.ly/Q045DZ1r0"
                  ><i
                    class="ml-2 fa fa-download text-white cursor-pointer"
                  ></i>
                </a>

                <span class="tooltip-text">Download Agreement</span>
              </div>
              <div
                class="-mx-3 md:flex mb-6"
                v-if="form.attorney_type.includes('FAM')"
              >
                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                  <div class="p-3">
                    <input
                      type="checkbox"
                      id="review_agreements"
                      v-model="form.review_agreements"
                      aria-label="I have reviewed the Fee Schedule and the Fee for Services Attorney Agreement"
                      class="focus:ring-indigo-500 h-6 w-6 cobalt-text-color border-gray-300 rounded"
                    />
                    <span class="ml-2 text-gray-800"
                      >I have reviewed the Fee Schedule & the Fee for Services
                      Attorney Agreement
                      <span class="text-red-700">*</span></span
                    >
                    <div
                      class="text-red-600 mt-1 text-sm"
                      v-for="(error, index) in v$.form.review_agreements
                        .$errors"
                      :key="index"
                    >
                      <div v-if="error.$validator == 'required'">
                        Please accept agreement
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
// import TextInput from "../components/Layout/Form/TextInput.vue"; // importing resuable input field
import useVuelidate from "@vuelidate/core"; // importing validation library
import { required } from "@vuelidate/validators"; // importing diffrene validation types from library.
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import Constants from "../../constants.ts"; // importing constant resubale variables.

export default {
  name: "AppPreview",
  setup() {
    return { v$: useVuelidate() }; //creating object to access validation object.
  },
  props: ["forms"], // To access variable which is passed from Parent component.
  computed: mapState(["att_user", "profile_data","tempAttData"]), // get central level variable from store
  data: function() {
    return {
      //Variables for this component
      API_BASE: Constants.API_BASE,
      form: this.forms,
      errors: [],
      sizes: ["lg", "md", "sm"],
      config: {
        wrap: true,
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
    };
  },
  validations() {
    //For Required and other validation
    let is_required = {};
    if (this.form.attorney_type.includes("FAM")) {
      is_required = { required };
    } else {
      is_required = {};
    }
    return {
      form: {
        review_agreements: is_required,
      },
    };
  },
  components: {
    // VueGoogleAutocomplete,
    // TextInput,
  },
  created() {
    //If attorney login success and coming for update Application
    if (this.att_user?.data && this.att_user != undefined) {
      setTimeout(() => {
        document.getElementById("review_agreements").checked = true;
        this.form.review_agreements = true;
      }, 500);
    }
  },
  methods: {
    download: function(path) {
      //For Download Pdf
      window.open(path);
    },
    submitApplication: function() {
      //For validate form
      this.v$.form.$touch(this.v$.form.errors);
      if (this.v$.form.$pending || this.v$.form.$error) return;
    },
  },
};
</script>
